//----------------------------------------------------------
// js/common.js を読みだすモジュール全体で $ を使用可能にします。
//----------------------------------------------------------
import jQuery from 'jquery';
window.$ = jQuery;
window.jQuery = jQuery;

// moment
var moment = require('moment');
// datepicker
require('jquery-ui/ui/widgets/datepicker');
//require('jquery-ui/ui/i18n/datepicker-ja');
require('jquery-datetimepicker');

$(function () {

    $('head').prepend('<meta name="viewport" content="width=1024">');

    window.onpageshow = function() {
        $('.loading').addClass('hide');
    }

    //タブ
    $(".mod-tab a").click(function () {
        $(this).parent().addClass("active").siblings(".active").removeClass("active");
        var tabContents = $(this).attr("href");
        $(tabContents).addClass("active").siblings(".active").removeClass("active");
        return false;
    });

    //お気に入り アコーディオン
    $(".dropdown").hide();
    $(".triger").on('click', function () {
        $(this).prev().slideToggle();
        $(this).find('.btn-more').toggleClass("close");

    });
    // 使われていないので多言語未対応
    $(this).find('.btn-more').on('click', function () {
        if ($(this).text() === '閉じる') {
            $(this).text('続きを表示');
        } else {
            $(this).text('閉じる');
        }
    });

    //お気に入り タブ
    $(".mod-tab-favorite a").click(function () {
        $(this).parent().addClass("active").siblings(".active").removeClass("active");
        var tabContents = $(this).attr("href");
        $(tabContents).addClass("active").siblings(".active").removeClass("active");
        return false;
    });

    //お気に入り #tab1に１つでもチェックがあったらselectedを付ける
    //tab1のチェックボックスは$checkBox
    var $checkBox = $('#tab1 input[type="checkbox"]');
    //tab1のチェックボックスがクリックされた
    $checkBox.on("click", function () {
        //tab1のチェックされた数を数える
        var cnt = $('#tab1 input:checkbox:checked').length;
        //チェックの数がタブの数と同じなら（すべてチェックされてるなら
        if (cnt == $('#tab1 :input').length) {
            //iからselectedを外す
            $('.tab1 i').removeClass('selected');
            $('#all-j1').prop('checked', true);
            //チェックの数が0より大きければ
        } else if (cnt > 0) {
            //iにselectedをつける
            $('.tab1 i').addClass('selected');
            $('#all-j1').prop('checked', false);
        } else {
            //どちらにも一致しない場合は、selectedを外す
            $('.tab1 i').removeClass('selected');
        }
    });

    var $checkBox = $('#tab2 input[type="checkbox"]')
    $checkBox.on("click", function () {
        var cnt = $('#tab2 input:checkbox:checked').length;
        if (cnt == $('#tab2 :input').length) {
            $('.tab2 i').removeClass('selected');
            $('#all-j2').prop('checked', true);
        } else if (cnt > 0) {
            $('.tab2 i').addClass('selected');
            $('#all-j2').prop('checked', false);
        } else {
            $('.tab2 i').removeClass('selected');
        }
    });

    var $checkBox = $('#tab3 input[type="checkbox"]')
    $checkBox.on("click", function () {
        var cnt = $('#tab3 input:checkbox:checked').length;
        if (cnt == $('#tab3 :input').length) {
            $('.tab3 i').removeClass('selected');
            $('#all-j3').prop('checked', true);
        } else if (cnt > 0) {
            $('.tab3 i').addClass('selected');
            $('#all-j3').prop('checked', false);
        } else {
            $('.tab3 i').removeClass('selected');
        }
    });

    //all-j1
    $('#all-j1').on('click', function () {
        //tab1のチェックされた数を数える
        var cnt = $('#tab1 input:checkbox:checked').length;
        //チェックの数が0より大きければ
        if (cnt > 0) {
            //#tab1のすべてのチェックを外す
            $("#tab1 input[type='checkbox']").prop('checked', false);
            $('#all-j1').prop('checked', false);
            //iからselectedを外す
            $('.tab1 i').removeClass('selected');
            //それ以外
        } else {
            //#tab1のすべてをチェックする
            $("#tab1 input[type='checkbox']").prop('checked', this.checked);
        }
    });

    //J2
    $('#all-j2').on('click', function () {
        var cnt = $('#tab2 input:checkbox:checked').length;
        if (cnt > 0) {
            $("#tab2 input[type='checkbox']").prop('checked', false);
            $('#all-j2').prop('checked', false);
            $('.tab2 i').removeClass('selected');
        } else {
            $("#tab2 input[type='checkbox']").prop('checked', this.checked);
        }
    });

    //J3
    $('#all-j3').on('click', function () {
        var cnt = $('#tab3 input:checkbox:checked').length;
        if (cnt > 0) {
            $("#tab3 input[type='checkbox']").prop('checked', false);
            $('#all-j3').prop('checked', false);
            $('.tab3 i').removeClass('selected');
        } else {
            $("#tab3 input[type='checkbox']").prop('checked', this.checked);
        }
    });

    //Jリーグ全て
    $('#all-j').on('click', function () {
        //tab-contents-favのチェックされた数を数える
        var cnt = $('.tab-contents-fav input:checkbox:checked').length;
        //チェックの数が0より大きければ
        if (cnt > 0) {
            //favorit-headのiからselectedを外す
            $('.favorit-head i').removeClass('selected');
            $(".tab-contents-fav input[type='checkbox'],.favorit-head input[type='checkbox']").prop('checked', this.checked);
        } else {
            $(".mod-favorit-checkbox input[type='checkbox']").prop('checked', this.checked);
        }
    });

    //acordion
    var Trigger = ".js-trigger";
    $(Trigger).each(function () {
        $(this).on('click', function () {
            $(this).next().slideToggle();
            $(this).find('.fas').toggleClass('is-open');
        });
    });

    //モーダル
    var ModalOpen = ".js-modal-open";
    var ModalAll = ".modal-wrapper";
    var ModalContents = ".box-dialog, .modal-contents";
    var ModalClose = ".js-modal-close";

    // モーダル開く
    $(ModalOpen).each(function () {
        $('body').on('click', ModalOpen, function (e) {
            var ModalTarget = $(this).data('target');
            var ModalThis = document.getElementById(ModalTarget);
            $(ModalThis).fadeIn(400);
            return false;
        });
    });

    // モーダル閉じる
    $(ModalClose).on('click', function () {
        $(ModalAll).fadeOut(400);
        return false;
    });
    var stopP = function (e) {
        e.stopPropagation();
    }
    $(ModalContents).on('click', stopP);
    window.$.extend({
        removeModalContentsStopP: function () {
            $('.modal-contents').off('click', stopP);
        },
    });

    // [C-5-20]番号表示切り替え
    $(".btn-switching").click(function () {
        if ($(this).hasClass("used")) {
            $(this).addClass("empty");
            $(this).removeClass("used");
        } else {
            $(this).addClass("used");
            $(this).removeClass("empty");
        }
    });

    //[C-5-3],[C-5-4]アコーディオン
    var MailToggleSwitch = ".toggle-swicth-01";
    var EnglishToggleSwitch = ".toggle-swicth-02";
    //通知メール文面アコーディオン
    $(MailToggleSwitch).click(function () {
        $(this).toggleClass("active");
        $(".toggle-contents-01").slideToggle();
    });
    // Englishアコーディオン
    $(EnglishToggleSwitch).click(function () {
        $(this).toggleClass("active");
        $(this).parent().children(".toggle-contents-02").slideToggle();
    });

    // datepickerオプション
    var datepickerOption = {
        showOn:"focus",
        dateFormat: 'yy/mm/dd',
        constrainInput: true
    }

    // datepicker
    $('.datepicker').datepicker(datepickerOption);
    $('body').on('click', '.show-datepicker', function() {
        var id = $(this).attr('id');

        $('#'+id+"_datepicker").datepicker('show')
    });
    // datetimepicker -- 時間のみ
    $('.timepicker').datetimepicker({datepicker:false,format:'H:i'});
    // datetimepicker -- 日時
    $('.datetimepicker').datetimepicker({format:'Y/m/d H:i'});
    $('.show-datetimepicker').click(function() {
        var id = $(this).attr('id');
        $('#'+id+"_datetimepicker").datetimepicker('show')
    });

    'use strict';
    // フラッシュメッセージのfadeout
    $(function(){
        $('.flash_message').fadeOut(3500);
    });

});
